<template>
  <div class="widthAuto">
    <headerTop @changeRoute="getRoute" @djsFp="djsFp" />
    <div class="wrap">
      <div class="main base-clear">
        <div
          id="leftBox"
          class="leftBox tab_box base-clear game_box_title t_1"
          style="background: white; overflow:hidden;margin-top: 40px"
        >
          <div class="game_box_title t_1" style="background-color: white; height: 100%">
            <table class="table0" style="width: 100%;border-radius: none;">
              <thead style="width: 100%;">
                <th id="my_bet" colspan="2" style="color: rgb(255, 255, 255); font-weight: bold; padding: 6px 0;  text-align: center;border-radius: 0;">我的注单</th>
              </thead>
            </table>
            <div class="history_wrap zchy" id="nice-scroll" style="height: calc(100% - 130px) !important; padding-top:0">
              <table class="table1">
                <tbody>
                  <tr>
                    <td class="td-norwrap">会员</td>
                    <td colspan="2">
                      <span id="print_mem">{{username}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-norwrap">期数</td>
                    <td colspan="2">
                      <span id="print_issue">{{qs}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-norwrap">时间</td>
                    <td colspan="2">
                      <span id="print_time">{{time}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-norwrap">编号</td>
                    <td colspan="2">
                      <span id="print_no" style="word-break: break-all;">{{bh}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table  class="table2">
                <tbody>
                  <tr>
                    <td>号码</td>
                    <td>赔率</td>
                    <td>金额</td>
                  </tr>
                  <tr v-for="(item , index) in huiyunDataList" :key="index">
                    <td>{{item.betNumber}}</td>
                    <td>{{formatPeilv(item.peilv, item.playCode)}}</td>
                    <td>{{(item.money * 1).toFixed(2) || '-'}}</td>
                  </tr>
                </tbody>
              </table>
              <div style="margin-top: 135px;" v-if="huiyunDataList.length == 0" class="no-message">
                <div style="display: flex; flex-direction: column;  align-items: center;color: #aaa;font-size: 14px;">
                  <!-- <i style="font-size: 40px; color: #aaa" class="icon icon-info-circle"></i> -->
                  <img src="../assets/images/no-message.png" style="width: 60px; height: 60px;" alt="">
                  暂无注单
                </div>
              </div>
              <table style="position: absolute; bottom: 0; left:0; right: 0;" class="table3">
                <tbody id="last_list">
                  <tr>
                    <td colspan="3">
                      总笔：
                      <span class="red">{{totalNum}}</span>总金额：
                      <span class="red">{{(zje * 1).toFixed(2) || '-'}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3">第{{qh}}期，1天内有效！！！</td>
                  </tr>
                  <tr>
                    <td colspan="3">
                      <input
                        id="clear-lastbet"
                        class="btn grayBtn"
                        type="button"
                        value="清除"
                        @click="clear()"
                      />
                      <input
                        id="print-lastbet"
                        class="btn hotBtn disSubmit"
                        type="button"
                        value="打印"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <router-view v-if="gameReady" ref="changeContainer" @yzdData="getData" />
      </div>
    </div>
    <footerBottom ref="changeRoute" />
    <audio id="bgm" hidden :src="require('../assets/music/msg.mp3')"></audio>
  </div>
</template>

<script>
import headerTop from "./header/headerTop";
import footerBottom from "./footerBottom/footerBottom";
import { printLastbet, setDefault, DataTime, qh } from "../assets/js/base";
import { bindGameFun, G, container } from "../assets/js/gamedefault";
import getData from "./getData/getData";
import 'jquery.nicescroll'
export default {
  name: "App",
  data() {
    return {
      canGetList: true,
      username: "",
      qs: "",
      ed: "",
      time: "-",
      zje: "0",
      totalNum: 0,
      bh: '-',
      je: "",
      qh: "",
      gameReady: false,
      huiyunDataList: []
    };
  },
  components: {
    headerTop,
    footerBottom
  },
  mounted() {

    document.getElementById('bgm').pause()
    //设置标题
    document.title = sessionStorage.getItem("title")
    if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
        var i = document.createElement('iframe');
        // i.src = '/favicon.ico';
        i.style.display = 'none';
        i.onload = function() {
            setTimeout(function(){
                i.remove();
            }, 9)
        }
        document.body.appendChild(i);
    }

    printLastbet(this); //调用打印机
    setDefault(); //设置默认主题颜色
    DataTime();
    this.$event.$on('gameInfoChanged', this.handleGameInfoChanged)
    this.loadUserInfo();
    let data = {};
    data.access_token = window.sessionStorage.getItem("login").split("&")[0];
    data.uid = window.sessionStorage.getItem("login").split("&")[1];
    getData.postAxiosMethod("gameinfo", data, res => {
        const gameInfo = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
        if (!gameInfo) {
          return;
        }
        const waitOpenIssue = gameInfo.wait_open_issue || gameInfo.nextQihao || "";
        window.sessionStorage.setItem("code", gameInfo.code);
        window.sessionStorage.setItem("qiNum", waitOpenIssue);
        window.sessionStorage.setItem("isClose", gameInfo.isClose);
        window.sessionStorage.setItem("gameName", gameInfo.gameName);
        window.sessionStorage.setItem("gameType", gameInfo.game_type || "five_ball");
        if (Array.isArray(gameInfo.nav)) {
          window.sessionStorage.setItem("gameNav", JSON.stringify(gameInfo.nav));
          this.$event.$emit("updateGameNav", gameInfo.nav);
        } else {
          window.sessionStorage.removeItem("gameNav");
          this.$event.$emit("updateGameNav", null);
        }
        if (Array.isArray(gameInfo.number)) {
          window.sessionStorage.setItem("gameNumber", JSON.stringify(gameInfo.number));
        }
        this.gameReady = true;
        this.getData()
        this.qs = waitOpenIssue
        this.qh = waitOpenIssue
      }
    )
    this.$nextTick(() => {
      let _this = this
      $('#nice-scroll').niceScroll({
          cursorcolor: "#424242", // 改变滚动条颜色，使用16进制颜色值
          cursoropacitymin: 0, // 当滚动条是隐藏状态时改变透明度, 值范围 1 到 0
          cursoropacitymax: 1, // 当滚动条是显示状态时改变透明度, 值范围 1 到 0
          cursorwidth: "8px", // 滚动条的宽度，单位：便素
          cursorborder: "1px solid #fff", // CSS方式定义滚动条边框
          cursorborderradius: "5px", // 滚动条圆角（像素）
          zindex: "auto" | 1, // 改变滚动条的DIV的z-index值
          scrollspeed: 60, // 滚动速度
          mousescrollstep: 40, // 鼠标滚轮的滚动速度 (像素)
          touchbehavior: false, // 激活拖拽滚动
          hwacceleration: true, // 激活硬件加速
          boxzoom: false, // 激活放大box的内容
          dblclickzoom: true, // (仅当 boxzoom=true时有效)双击box时放大
          gesturezoom: true, // (仅 boxzoom=true 和触屏设备时有效) 激活变焦当out/in（两个手指外张或收缩）
          grabcursorenabled: false, // (仅当 touchbehavior=true) 显示“抓住”图标display "grab" icon
          autohidemode: 'scroll', // 隐藏滚动条的方式, 可用的值:
          background: "", // 轨道的背景颜色
          iframeautoresize: true, // 在加载事件时自动重置iframe大小
          cursorminheight: 32, // 设置滚动条的最小高度 (像素)
          preservenativescrolling: true, // 你可以用鼠标滚动可滚动区域的滚动条和增加鼠标滚轮事件
          railoffset: false, // 可以使用top/left来修正位置
          bouncescroll: false, // (only hw accell) 启用滚动跳跃的内容移动
          spacebarenabled: true, // 当按下空格时使页面向下滚动
          railpadding: { top: 0, right: 0, left: 0, bottom: 0 }, // 设置轨道的内间距
          disableoutline: true, // 当选中一个使用nicescroll的div时，chrome浏览器中禁用outline
          horizrailenabled: true, // nicescroll可以管理水平滚动
          railalign: "right", // 对齐垂直轨道
          railvalign: "bottom", // 对齐水平轨道
          enabletranslate3d: true, // nicescroll 可以使用CSS变型来滚动内容
          enablemousewheel: true, // nicescroll可以管理鼠标滚轮事件
          enablekeyboard: true, // nicescroll可以管理键盘事件
          smoothscroll: true, // ease动画滚动
          sensitiverail: true, // 单击轨道产生滚动
          enablemouselockapi: true, // 可以用鼠标锁定API标题 (类似对象拖动)
          cursorfixedheight: false, // 修正光标的高度（像素）
          hidecursordelay: 400, // 设置滚动条淡出的延迟时间（毫秒）
          directionlockdeadzone: 6, // 设定死区，为激活方向锁定（像素）
          nativeparentscrolling: true, // 检测内容底部便于让父级滚动
          enablescrollonselection: true, // 当选择文本时激活内容自动滚动
          cursordragspeed: 0.3, // 设置拖拽的速度
          rtlmode: "auto", // DIV的水平滚动从左边开始
          cursordragontouch: false, // 使用触屏模式来实现拖拽
          oneaxismousemode: "auto", // 当只有水平滚动时可以用鼠标滚轮来滚动，如果设为false则不支持水平滚动，如果设为auto支持双轴滚动
          scriptpath: "", // 为boxmode图片自定义路径 ("" => same script path)
          preventmultitouchscrolling: true // 防止多触点事件引发滚动
      });
      $('#nice-scroll').scroll(function(e){
        if(this.scrollHeight - this.scrollTop <= (this.clientHeight + 150)){
          _this.getNextList()
        }
      })

    })
    // clearUserInfo(res.data.data); //点击清除按钮
  },
  beforeDestroy() {
    this.$event.$off('gameInfoChanged', this.handleGameInfoChanged)
  },
  methods: {
    formatPeilv(peilv, playCode) {
      const number = peilv * 1;
      if (isNaN(number)) {
        return "-";
      }
      const str = peilv == null ? "" : peilv.toString();
      return str
        .replace(/(\.\d*?[1-9])0+$/, "$1")
        .replace(/\.0+$/, "");
    },
    handleGameInfoChanged(gameInfo) {
      const issue = gameInfo && gameInfo.issue ? gameInfo.issue : window.sessionStorage.getItem("qiNum");
      this.qs = issue || "";
      this.qh = issue || "";
      this.huiyunDataList = [];
      this.zje = "0";
      this.totalNum = 0;
      this.bh = "-";
      this.time = "-";
      this.canGetList = true;
      this.getData();
    },
    async getNextList(){

      if(!this.canGetList){
        return
      }
      this.canGetList = false
      let data = {};
      data.access_token = window.sessionStorage.getItem("login").split("&")[0];
      data.uid = window.sessionStorage.getItem("login").split("&")[1];
      data.game_code = window.sessionStorage.getItem("code");
      data.id = this.huiyunDataList[this.huiyunDataList.length - 1].id
      getData.postAxiosMethod("currentissuebetlist", data, res => {
          this.canGetList = true
          let list = res.data.data.filter(item => item.ispei == 0)
          if(res.data.length != 0){
            this.huiyunDataList = [
              ...this.huiyunDataList,
              ...list,
            ]
            this.zje = (res.data.totalMoney * 1)
            this.totalNum = (res.data.totalNum * 1)
            // this.huiyunDataList.forEach(item =>{
            //   if(item.ispei == 0){
            //     this.zje += (item.money * 1)
            //   }
            // })
            this.zje.toFixed(2)
            this.time = this.getLocalTime(res.data.betTime);
            this.bh = res.data.orderId || '-'
            this.getLeftBoxInfo()
            this.$nextTick(() => {
              $("#nice-scroll").getNiceScroll(0).resize();
            })
          }else{
            this.qs = window.sessionStorage.getItem("qiNum")
          }
        });
    },
    djsFp(type) {

      this.$refs.changeContainer.djsFp(type);
    },
    getData(type) {
      let data = {};
      data.access_token = window.sessionStorage.getItem("login").split("&")[0];
      data.uid = window.sessionStorage.getItem("login").split("&")[1];
      data.game_code = window.sessionStorage.getItem("code");
      if (type == 1) {
        data.play_type = "zhixuan";
      } else if (type == 2) {
        data.play_type = "zhixuan";
      } else if (type == 3) {
        data.game_code = window.sessionStorage.getItem("code");
        data.play_type = "kuaida";
      } else if (type == 4) {
        data.game_code = window.sessionStorage.getItem("code");
        data.play_type = "kuaixuan";
      }
      setTimeout(() => {
        getData.postAxiosMethod("currentissuebetlist", data, res => {
          if(res.data.length != 0){
            this.huiyunDataList = res.data.data.filter(item => {
              return item.ispei == 0
            });
            this.zje = (res.data.totalMoney * 1)
            this.totalNum = (res.data.totalNum * 1)
            // this.huiyunDataList.forEach(item =>{
            //   if(item.ispei == 0){
            //     this.zje += (item.money * 1)
            //   }
            // })
            this.zje.toFixed(2)
            this.time = this.getLocalTime(res.data.betTime);
            this.bh = res.data.orderId || '-'
            this.getLeftBoxInfo()
          }else{
            this.qs = window.sessionStorage.getItem("qiNum")
          }
        });
        this.$event.$emit('updateUserInfo')
      },1000)

    },
    loadUserInfo() {
      const _this = this;
      this.qh = window.sessionStorage.getItem("qiNum");
      let data = {};
      data.access_token = window.sessionStorage.getItem("login").split("&")[0];
      data.uid = window.sessionStorage.getItem("login").split("&")[1];
      getData.postAxiosMethod("userinfo", data, res => {
        let date = new Date();
        _this.username = res.data.data.username;
        _this.ed = res.data.data.balance;
        _this.ky = res.data.data.credits;
        // _this.time = date.Format(
        //   "MM-dd HH:mm",
        //   date.setTime(res.data.data.loginTime * 1000)
        // );
        _this.je = res.data.data.isplayer;
        // _this.zje = res.data.data.balance;

        sessionStorage.setItem('Voice', res.data.data.isplayer)
      });
    },
    clear() {
      let data = {}
      data.access_token = window.sessionStorage.getItem("login").split("&")[0];
      data.game_code = window.sessionStorage.getItem("code");
      data.uid = window.sessionStorage.getItem("login").split("&")[1];
      getData.postAxiosMethod("chearBetList", data, res => {
        this.huiyunDataList = []
        this.zje = "0"
        this.totalNum = "0"
      })

    },
    getRoute(title) {
      this.$refs.changeRoute.closeWin();
      if (
        title == "信用资料" ||
        title == "安全退出" ||
        title == "修改密码" ||
        title == "历史开奖" ||
        title == "玩法规则" ||
        title == "线路切换" ||
        title == "公告"
      ) {
        this.$refs.changeContainer.removeTabIndex()
        this.$refs.changeRoute.openWin(title);
      } else {
        this.$refs.changeContainer.changeContainer(title);
      }
    },
    //获取leftBox内的数据
    getLeftBoxInfo(){
      let _this = this
      let data = {};
      data.access_token = window.sessionStorage.getItem("login").split("&")[0];
      data.uid = window.sessionStorage.getItem("login").split("&")[1];
      data.game_code = window.sessionStorage.getItem("code")  || 'hn5fc';
      getData.postAxiosMethod("bet/betlist", data, res => {
        if(res.data.data.length != 0){
          res.data.data.forEach(item => {
            item.betTime = this.getLocalTime(item.betTime);
          });
          let index = res.data.data.length - 1
          // this.time = res.data.data[index].betTime
          const issue = res.data.data[0] && res.data.data[0].issue
          this.qs = issue || window.sessionStorage.getItem("qiNum") || this.qs
        }
        _this.loadUserInfo()
      })
    },
    getLocalTime(nS) {
      if(nS){
        let time = new Date(parseInt(nS) * 1000)
          .toLocaleString()
          .replace(/\//g, "-");
        if (time.includes("下午")) {
          time = time.replace(
            /上午|下午\d/g,
            12 + parseInt(time[time.indexOf("下午") + 2])
          );
        } else {
          time = time.replace(/上午|下午/g, " ");
        }
        return time;
      }else{
        return '-'
      }

    },
  }
};
</script>
 <style>
 @font-face{
    font-family:'FontAwesome';
    src:url('http://libs.baidu.com/fontawesome/4.1.0/fonts/fontawesome-webfont.eot?v=4.1.0');
    src:url('http://libs.baidu.com/fontawesome/4.1.0/fonts/fontawesome-webfont.eot?#iefix&v=4.1.0') format('embedded-opentype'), url('http://libs.baidu.com/fontawesome/4.1.0/fonts/fontawesome-webfont.woff?v=4.1.0') format('woff'), url('http://libs.baidu.com/fontawesome/4.1.0/fonts/fontawesome-webfont.ttf?v=4.1.0') format('truetype'), url('http://libs.baidu.com/fontawesome/4.1.0/fonts/fontawesome-webfont.svg?v=4.1.0#fontawesomeregular') format('svg');
    font-weight:normal;font-style:normal;
  }
 .widthAuto {
   min-width: 1500px !important;
 }
.t_1 .zchy {
  /* height: 100% !important; */
  overflow: hidden;
}
.td-norwrap {
  white-space: nowrap;
  padding: 0 5px;
}
[class*='icon-']:before{display:inline-block;font-family:"FontAwesome";font-weight:normal;font-style:normal;vertical-align:baseline;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
.icon-info-circle:before{content:"\f05a";}
</style>
